import React, {useEffect} from "react";
import enlilImage from "../../assets/logo-5cd08655.svg";
import css_self from "./css/NavBar.module.scss";
import "./css/NavBar.scss";
import {Tooltip, Avatar, Box, Button, IconButton, Menu, MenuItem, Popover, Typography} from "@mui/material";
import {Blue3, Grey2, Grey17, Grey6, White} from "../../theme/styles";
import {useNavigate} from "react-router-dom";
import {Apps, Folder, SyncAlt, SupervisorAccount, WorkOutline, ThumbUp, HelpOutlineOutlined, Logout, PermIdentity, Sync, SwitchAccount, Settings} from "@mui/icons-material";
import useAppContext from "../../util/AppContext";
import EventBus from "../../util/EventBus";
import {Company, SessionContext} from "../../util/SessionContext";
import css_buttons from "../Common/css/CCButton.module.scss";
import axios from "axios";
import {SwitchCompany} from "../Login/SwitchCompany";
import css_link from "../Common/css/Link.module.scss";

type MenuSelection = {id: string, target: EventTarget & HTMLButtonElement}


export default function NavBar() {
    const navigate = useNavigate();
    const [showSwitchCompany, setShowSwitchCompany] = React.useState<boolean>(false);
    const [canAccessProjectPlan, setCanAccessProjectPlan] = React.useState<boolean>(true);
    const [canAccessAdministration, setCanAccessAdministration] = React.useState<boolean>(false);
    const [menu, setMenu] = React.useState<MenuSelection | null>(null);
    const sessionContext:SessionContext = useAppContext()?.sessionContext!;

    useEffect(() => {
        const sessionUpdateListener = () => {
            // @ts-ignore
            if (sessionContext.getPrivileges() && sessionContext.getPrivileges().length > 0) {
                // let privilege: string | undefined = sessionContext.getPrivileges().find((p: string) => p === "Project Plan");
                // if (privilege) setCanAccessProjectPlan(true)

                let privilege = sessionContext.getPrivileges().find((p: string) => p === "PROJECT_MILESTONE_ADMINISTRATION");
                if (privilege) setCanAccessAdministration(true)
            }
        };

       // @ts-ignore
        EventBus.session.addListener("update", sessionUpdateListener);
        EventBus.components.addListener("switch-company-close", onSwitchCompanyClose)
        sessionUpdateListener();

       // @ts-ignore
        return () => {
            EventBus.session.removeListener("update", sessionUpdateListener);
            EventBus.components.removeListener("switch-company-close", onSwitchCompanyClose);
        }
    }, [sessionContext]);

    let content = (
        <div style={{display: "flex", flexDirection: "column", justifyContent: "flex-start"}}>
            <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-start", paddingLeft: 20, height: "50px", borderBottomWidth: "1px", borderBottomStyle: "solid", borderBottomColor: Grey2, backgroundColor: White}}>
                <div key={1} style={{display: "flex", flexDirection: "row", justifyContent: "flex-start"}}>
                    <div key={1} style={{paddingTop: "0px", paddingRight: "2px", marginLeft: "-5px"}}><img className={css_self.EnlilLogo} src={enlilImage} alt="Home"/></div>
                    <div key={2} style={{paddingTop: "5px", marginLeft: "65px", marginRight: "4px"}}><Typography style={{fontSize: 24, fontWeight: 400, color: Blue3}}>|</Typography></div>
                    <div key={3} style={{paddingTop: "7px", marginLeft: "3px"}}><Typography style={{fontSize: 24, fontWeight: 400, color: Blue3}}>PM</Typography></div>
                </div>
                <div key={2} style={{display: "flex", flexDirection: "row", justifyContent: "flex-start", flexGrow: 1, paddingTop: "6px", marginLeft: "30px"}}>
                </div>
                <div key={3} style={{display: "flex", flexDirection: "row", justifyContent: "flex-end", minWidth: "260px", paddingTop: "4px"}}>
                    {sessionContext.valid() ? (
                        <div style={{width: "45px", paddingTop: "3px"}}>{renderVisibilityNavigation()}</div>
                    ) : null}
                    <div style={{width: "45px", paddingTop: "1px"}}>{renderAccountNavigation()}</div>
                    {sessionContext.valid() ? (
                        <div style={{width: "45px", paddingTop: "1px"}}>{renderAppsNavigation()}</div>
                    ) : null}
                </div>
            </div>
            {renderSiteNavigation()}
        </div>
    )

    function onSwitchCompanyClose() {
        setShowSwitchCompany(false)
    }

    return (
        <>
            {showSwitchCompany ? <SwitchCompany/> : null}
            {content}
        </>
    );

    function renderSiteNavigation() {
        let content = null;

        if (menu?.id === "sites") {
            content = (
                <div style={{display: "flex", flexDirection: "column"}}>
                    <div style={{marginBottom: "30px"}}>
                        <IconButton className={css_self.AppMenuButton}
                                    style={{width: "100%"}}
                                    onClick={() => {
                                        navigate("/apidocstools/apiexplorer");
                                    }}
                        >
                            <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-start", height: "50px", width: "100%"}}>
                                <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-start", width: "20%", minWidth: "300px"}}>
                                    <div style={{paddingTop: "20px", paddingRight: "2px"}}><img className={css_self.EnlilLogo} src={enlilImage} alt="Home"/></div>
                                    <div style={{paddingTop: "25px", marginLeft: "65px", marginRight: "4px"}}><Typography style={{fontSize: 24, fontWeight: 400, color: Blue3}}>|</Typography></div>
                                    <div style={{paddingTop: "27px", marginLeft: "3px"}}><Typography style={{fontSize: 24, fontWeight: 400, color: Blue3}}>BPM</Typography></div>
                                </div>
                                <div style={{paddingTop: "7px", width: "80%"}}>
                                    <Typography style={{fontSize: "14px", fontWeight: "400", color: "#000000", textAlign: "left"}}>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</Typography>
                                </div>
                            </div>
                        </IconButton>
                    </div>
                </div>
            )
        }

        return content;
    }

    function stringAvatar(name: string) {
        return name
            .split(" ")
            .map(word => word[0])
            .join("")
            .substring(0, 2);
    }

    async function refresh() {
        // @ts-ignore
        axios({
            method: "PUT",
            baseURL: process.env.REACT_APP_API_URL,
            url: "t8/v1/authenticate",
            json: true,
            data: {
                "X-Enlil-RefreshToken": sessionContext.getRefreshToken(),
            },
        }).then(response => {
            let visibilityMode, visibilityValue
            if (response.data["Company"]["Positions"].length > 0) {
                visibilityMode = "Position";
                visibilityValue = response.data["Company"]["Positions"][0].USID;
            } else if (response.data["Company"]["UserGroups"].length > 0) {
                visibilityMode = "UserGroup";
                visibilityValue = response.data["Company"]["UserGroups"][0].USID;
            } else if (response.data["Company"]["WorkGroups"].length > 0) {
                visibilityMode = "WorkGroup";
                visibilityValue = response.data["Company"]["WorkGroup"][0].USID;
            }

            sessionContext.setActiveVisibility(visibilityMode!, visibilityValue)
            sessionContext.setIdentityToken(response.data["IdentityToken"])
            sessionContext.setSessionUSID(response.data["Session"])
            sessionContext.setAccessToken(response.data["AccessToken"])
            sessionContext.setRefreshToken(response.data["RefreshToken"])
            sessionContext.setCompanyName(response.data["Company"]["CompanyName"])
            sessionContext.setEmployeeUSID(response.data["Company"]["EmployeeUSID"])
            sessionContext.setCompany(response.data["Company"])
            sessionContext.setRoles(response.data["Roles"])
            sessionContext.setPrivileges(response.data["NewPrivileges"])
            sessionContext.setTenants(response.data["Tenants"])
            sessionContext.setShowLoginDialog(false)
            sessionContext.setPickValues(response.data["PickValues"])
            sessionContext.setS3AccessKeyId(response.data["S3AccessKeyId"])
            sessionContext.setS3SecretAccessKey(response.data["S3SecretAccessKey"])
            sessionContext.setS3SessionToken(response.data["S3SessionToken"])

            window.location.href="/";
        }).catch(() => {
            EventBus.error.emit("show-system-error");
        });
    }

    function renderAccountNavigation() {
        let accountMarkup = (
            <div style={{marginTop: "5px"}}>
                <a className={css_link.link} href={process.env.REACT_APP_API_URL + "/t8/v1/authenticate"} rel="noreferrer"><PermIdentity/></a>
            </div>
        )
        if (sessionContext.valid()) {
            accountMarkup = (
                <Button className={css_self.NavMenuButton} variant="text" onClick={(e) => setMenu({id: "account", target: e.currentTarget})}>
                    <Avatar sx={{marginTop: "2px", bgcolor: Blue3, width: 35, height: 35}}>{stringAvatar(sessionContext.getName())}</Avatar>
                </Button>
            )
        }

        return (
            <div>
                {accountMarkup}
                {menu?.id === "account" ? (
                    <Menu anchorEl={menu.target}
                          anchorOrigin={{vertical: "bottom", horizontal: "right"}}
                          transformOrigin={{vertical: -16, horizontal: "center"}}
                          open={true}
                          onClose={() => setMenu(null)}
                          TransitionProps={{
                              onExited: () => setMenu(null),
                          }}
                          MenuListProps={{
                              ...{"data-cc-component": "NavMenu"},
                              disablePadding: true,
                              style: {"minWidth": "200px"},
                          }}
                    >
                        <MenuItem key={"account"} disabled className={css_self.Standard}>
                            <Typography component="div" style={{fontSize: "15px", fontWeight: "400", color: Grey17}}>Company: <b>{sessionContext.getCompanyName()}</b></Typography>
                        </MenuItem>
                        <MenuItem key={"name"} disabled className={css_self.Standard}>
                            <Typography component="div" style={{fontSize: "15px", fontWeight: "400", color: Grey17}}>Hello, <b>{sessionContext.getName()}</b></Typography>
                        </MenuItem>
                        <MenuItem divider key={"help"} className={css_self.Standard} onClick={() => {
                            setMenu(null);
                            navigate("/help");
                        }}>
                            <HelpOutlineOutlined style={{color: Grey6}} />
                            <Typography style={{fontSize: "15px", fontWeight: "400", color: Grey17}}>Help</Typography>
                        </MenuItem>
                        <MenuItem divider key={"settings"} className={css_self.Standard} onClick={() => {
                            setMenu(null);
                            navigate("/myenlil");
                        }}>
                            <Settings style={{color: Grey6}} />
                            <Typography style={{fontSize: "15px", fontWeight: "400", color: Grey17}}>My Enlil</Typography>
                        </MenuItem>
                        <MenuItem divider key={"switchCompany"} className={css_self.Standard} onClick={() => {
                            setShowSwitchCompany(true);
                            setMenu(null);
                        }}>
                            <SwitchAccount style={{color: Grey6}} />
                            <Typography style={{fontSize: "15px", fontWeight: "400", color: Grey17}}>Switch Company</Typography>
                        </MenuItem>
                        <MenuItem divider key={"refresh"} className={css_self.Standard} onClick={() => {
                            setMenu(null);
                            refresh();
                        }}>
                            <Sync style={{color: Grey6}} />
                            <Typography style={{fontSize: "15px", fontWeight: "400", color: Grey17}}>Refresh</Typography>
                        </MenuItem>
                        <MenuItem divider key={"logout"} className={css_self.Standard} onClick={() => {
                            setMenu(null);
                            navigate("/logout");
                        }}>
                            <Logout style={{color: Grey6}} />
                            <Typography style={{fontSize: "15px", fontWeight: "400", color: Grey17}}>Log out</Typography>
                        </MenuItem>
                    </Menu>
                ) : null}
            </div>
        );
    }

    function renderVisibilityNavigation() {
        let company: Company = sessionContext.getCompany()!;

        return (
            <>
                <Tooltip title="Personas" placement="bottom">
                    <IconButton className={css_self.NavMenuButton} style={{marginTop: "-1px"}} onClick={(e) => setMenu({id: "visibility", target: e.currentTarget})}>
                        <SyncAlt />
                    </IconButton>
                </Tooltip>
                {menu?.id === "visibility" ? (
                    <Menu anchorEl={menu?.target}
                          anchorOrigin={{vertical: "bottom", horizontal: "right"}}
                          transformOrigin={{vertical: -17, horizontal: "right"}}
                          open={true}
                          onClose={() => setMenu(null)}
                          TransitionProps={{
                              onExited: () => setMenu(null),
                          }}
                          MenuListProps={{
                              ...{"data-cc-component": "NavMenu"},
                              disablePadding: true,
                              style: {"minWidth": "300px"},
                          }}
                    >
                        {company.Positions.length > 0 ? (
                            <>
                                <MenuItem key="position-header" disabled className={css_self.Standard}>
                                    <div style={{display: "block", marginLeft: "10px"}}>
                                        <Typography style={{fontSize: "15px", color: Grey17, fontWeight: "400"}}>Positions</Typography>
                                    </div>
                                </MenuItem>
                                {company.Positions.map(position => (
                                    <MenuItem key={position.USID} className={css_self.Standard} onClick={() => {
                                        setMenu(null);
                                        sessionContext.setActiveVisibility("Position", position.USID);
                                        EventBus.visibility.emit("change-visibility", "Position");
                                    }}>&emsp;&emsp;
                                        <SupervisorAccount style={{color: Grey17}} />
                                        <div style={{display: "block", marginLeft: "10px"}}>
                                            <Typography style={{fontSize: "15px", color: Grey17, fontWeight: "400"}}>{position.Name}</Typography>
                                        </div>
                                    </MenuItem>
                                ))}
                            </>
                        ) : null}
                        {company.UserGroups.length > 0 ? (
                            <>
                                <MenuItem key="userGroup-header" disabled className={css_self.Standard}>
                                    <div style={{display: "block", marginLeft: "10px"}}>
                                        <Typography style={{fontSize: "15px", color: Grey17, fontWeight: "400"}}>User Groups</Typography>
                                    </div>
                                </MenuItem>
                                {company.UserGroups.map(userGroup => (
                                    <MenuItem key={userGroup["USID"]} className={css_self.Standard} onClick={() => {
                                        setMenu(null);
                                        sessionContext.setActiveVisibility("User Group", userGroup.USID);
                                        EventBus.visibility.emit("change-visibility", "User Group");
                                    }}>&emsp;&emsp;
                                        <ThumbUp style={{color: Grey17}} />
                                        <div style={{display: "block", marginLeft: "10px"}}>
                                            <Typography style={{fontSize: "15px", color: Grey17, fontWeight: "400"}}>{userGroup.Name}</Typography>
                                        </div>
                                    </MenuItem>
                                ))}
                            </>
                        ) : null}
                        {company.WorkGroups.length > 0 ? (
                            <>
                                <MenuItem key="workgroup-header" disabled className={css_self.Standard}>
                                    <div style={{display: "block", marginLeft: "10px"}}>
                                        <div>
                                            <Typography style={{fontSize: "15px", color: Grey17, fontWeight: "400"}}>Work Groups</Typography>
                                        </div>
                                    </div>
                                </MenuItem>
                                {company.WorkGroups.map(workgroup => (
                                    <MenuItem key={workgroup.USID} className={css_self.Standard} onClick={() => {
                                        setMenu(null);
                                        sessionContext.setActiveVisibility("Work Group", workgroup.USID);
                                        EventBus.visibility.emit("change-visibility", "Work Group");
                                    }}>&emsp;&emsp;
                                        <WorkOutline style={{color: Grey17}} />
                                        <div style={{display: "block", marginLeft: "10px"}}>
                                            <Typography style={{fontSize: "15px", color: Grey17, fontWeight: "400"}}>{workgroup.Name}</Typography>
                                        </div>
                                    </MenuItem>
                                ))}
                            </>
                        ) : null}
                    </Menu>
                ) : null}
            </>
        );
    }

    function renderAppsNavigation() {
        return (
            <div style={{marginRight: "10px", marginTop: "7px"}}>
                <IconButton className={css_buttons.blueIconButton} onClick={(e) => setMenu({id: "apps", target: e.currentTarget})}>
                    <Apps/>
                </IconButton>
                {menu?.id === "apps" ? (
                    <Popover anchorEl={menu.target}
                             anchorOrigin={{vertical: "bottom", horizontal: "right"}}
                             transformOrigin={{vertical: -9, horizontal: "left"}}
                             open={menu !== null}
                             onClose={() => setMenu(null)}
                             TransitionProps={{
                                 onExited: () => setMenu(null),
                             }}
                    >
                        <Box sx={{p: 2, bgcolor: "background.paper", width: "150px", height: "200px"}}>
                            <div style={{display: "flex", flexDirection: "column", padding: "10px"}}>
                                <div style={{display: "flex", flexDirection: "row", alignContent: "flex-start"}}>
                                    <div style={{width: "100spx", display: "flex", flexDirection: "column", justifyContent: "center", marginLeft: "auto", marginRight: "auto"}}>
                                        <IconButton className={css_self.AppMenuButton}
                                            onClick={() => {
                                                setMenu(null);
                                                navigate("/project-plan");
                                            }}>
                                            <Folder sx={{color: canAccessProjectPlan ? "#1498D8" : "#BAC3CE", width: 45, height: 45}}/>
                                        </IconButton>
                                        <Typography style={{fontSize: "14px", fontWeight: "400", color: canAccessProjectPlan ? "#000000" : "#BAC3CE", textAlign: "center"}}>Projects</Typography>
                                    </div>
                                </div>
                            </div>
                            <div style={{display: "flex", flexDirection: "column", padding: "10px"}}>
                                <div style={{display: "flex", flexDirection: "row", alignContent: "flex-start"}}>
                                    <div style={{width: "100spx", display: "flex", flexDirection: "column", justifyContent: "center", marginLeft: "auto", marginRight: "auto"}}>
                                        <IconButton className={css_self.AppMenuButton}
                                            onClick={() => {
                                                setMenu(null);
                                                if (canAccessAdministration) {
                                                    navigate("/administration");
                                                }
                                            }}>
                                            <Folder sx={{color: canAccessAdministration ? "#1498D8" : "#BAC3CE", width: 45, height: 45}}/>
                                        </IconButton>
                                        <Typography style={{fontSize: "14px", fontWeight: "400", color: canAccessAdministration ? "#000000" : "#BAC3CE", textAlign: "center"}}>Administration</Typography>
                                    </div>
                                </div>
                            </div>
                        </Box>
                    </Popover>
                ) : null}
            </div>
        );
    }

}
